import React from "react";

export default function Icon({ name, size = 18, stroke = 1.6 }) {
  const s = size;
  const p = {
    width: s,
    height: s,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };
  switch (name) {
    case "search":
      return <svg {...p}><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>;
    case "heart":
      return <svg {...p}><path d="M12 21s-7-4.5-9.5-9A5.5 5.5 0 0 1 12 6.5 5.5 5.5 0 0 1 21.5 12C19 16.5 12 21 12 21Z" /></svg>;
    case "heart-fill":
      return <svg {...p} fill="currentColor" stroke="none"><path d="M12 21s-7-4.5-9.5-9A5.5 5.5 0 0 1 12 6.5 5.5 5.5 0 0 1 21.5 12C19 16.5 12 21 12 21Z" /></svg>;
    case "bag":
      return <svg {...p}><path d="M6 8h12l-1 12H7L6 8Z" /><path d="M9 8a3 3 0 0 1 6 0" /></svg>;
    case "user":
      return <svg {...p}><circle cx="12" cy="8" r="4" /><path d="M4 21c1.5-4 5-6 8-6s6.5 2 8 6" /></svg>;
    case "menu":
      return <svg {...p}><path d="M4 7h16M4 12h16M4 17h16" /></svg>;
    case "x":
      return <svg {...p}><path d="m6 6 12 12M18 6 6 18" /></svg>;
    case "arrow-r":
      return <svg {...p}><path d="M5 12h14m-5-5 5 5-5 5" /></svg>;
    case "arrow-l":
      return <svg {...p}><path d="M19 12H5m5 5-5-5 5-5" /></svg>;
    case "minus":
      return <svg {...p}><path d="M5 12h14" /></svg>;
    case "plus":
      return <svg {...p}><path d="M5 12h14M12 5v14" /></svg>;
    case "filter":
      return <svg {...p}><path d="M4 5h16M7 12h10M10 19h4" /></svg>;
    case "grid":
      return <svg {...p}><rect x="4" y="4" width="7" height="7" /><rect x="13" y="4" width="7" height="7" /><rect x="4" y="13" width="7" height="7" /><rect x="13" y="13" width="7" height="7" /></svg>;
    case "list":
      return <svg {...p}><path d="M8 6h13M8 12h13M8 18h13" /><circle cx="4" cy="6" r="0.5" /><circle cx="4" cy="12" r="0.5" /><circle cx="4" cy="18" r="0.5" /></svg>;
    case "star":
      return <svg {...p} fill="currentColor" stroke="none"><path d="M12 2 14.5 8.5 21.5 9 16.2 13.6 17.8 20.5 12 17 6.2 20.5 7.8 13.6 2.5 9l7-.5L12 2Z" /></svg>;
    case "truck":
      return <svg {...p}><path d="M2 8h11v9H2zM13 11h4l3 3v3h-7" /><circle cx="6" cy="19" r="2" /><circle cx="17" cy="19" r="2" /></svg>;
    case "shield":
      return <svg {...p}><path d="M12 3 5 6v6c0 4.5 3 8 7 9 4-1 7-4.5 7-9V6l-7-3Z" /><path d="m9 12 2 2 4-4" /></svg>;
    case "share":
      return <svg {...p}><circle cx="6" cy="12" r="2" /><circle cx="18" cy="6" r="2" /><circle cx="18" cy="18" r="2" /><path d="m8 11 8-4M8 13l8 4" /></svg>;
    case "check":
      return <svg {...p}><path d="m5 12 5 5 9-11" /></svg>;
    case "chev-d":
      return <svg {...p}><path d="m6 9 6 6 6-6" /></svg>;
    case "chev-r":
      return <svg {...p}><path d="m9 6 6 6-6 6" /></svg>;
    case "trash":
      return <svg {...p}><path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13" /></svg>;
    case "edit":
      return <svg {...p}><path d="M4 20h4l11-11-4-4L4 16v4Z" /></svg>;
    case "leaf":
      return <svg {...p}><path d="M20 4c0 9-7 16-16 16 0-9 7-16 16-16Z" /><path d="M14 10 4 20" /></svg>;
    case "tag":
      return <svg {...p}><path d="M3 12V4h8l10 10-8 8L3 12Z" /><circle cx="7" cy="8" r="1.5" /></svg>;
    case "package":
      return <svg {...p}><path d="M21 8 12 3 3 8v8l9 5 9-5V8Z" /><path d="m3 8 9 5 9-5M12 13v9" /></svg>;
    default:
      return null;
  }
}
